export enum RequestStatus {
  Draft = 'Draft',
  Rejected = 'Rejected',
  MoreInfo = 'More Info',
  UnderProcess = 'Under Process',
  Approved = 'Approved',
}

export enum ProgressStatus {
  Draft,
  Rejected,
  MoreInfo,
  UnderProcess,
  Approved
}


export enum BorderTransportMeansMode {
 AirMode = '4',
 SeaMode = '1',
}


